import { useContext } from "react"
import { ClientesFornecedorContext } from "./ClientesFornecedorContext"

export function useClientesFornecedorContext() {
    return useContext(ClientesFornecedorContext)
}
